import CustomerInfo from "./CustomerInfo";
import CustomerInfoDetails from "./CustomerInfoDetails";
import CustomerInfoDetailsDetails from "./CustomerInfoDetailsDetails";
import CustomerInfoAppointmentDetails from "./CustomerInfoAppointmentDetails";
import CustomerInfoAppointmentViewDetails from "./CustomerInfoAppointmentViewDetails";

export {CustomerInfo, CustomerInfoDetails, CustomerInfoDetailsDetails, CustomerInfoAppointmentDetails, CustomerInfoAppointmentViewDetails}